import auth from '@/router/auth'
import UserIndex from '@/components/users-for-editor/Index'
import UserCreate from '@/components/users-for-editor/Create'
import UserUpdate from '@/components/users-for-editor/Update'
import UserUpdateTeacher from '@/components/users-for-editor/UpdateTeacher'
import UserUpdateFilterTeacher from '@/components/users-for-editor/UpdateFilterTeacher'
import UserShow from '@/components/users-for-editor/Show'
import UserPush from '@/components/users-for-editor/PushNoti'

export default [
  {
    path: '/users-for-editor',
    name: 'users-for-editor-index',
    component: UserIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users-for-editor/create',
    name: 'users-for-editor-create',
    component: UserCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users-for-editor/update/:id',
    name: 'users-for-editor-update',
    component: UserUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users-for-editor/update-teacher/:id',
    name: 'users-for-editor-update-teacher',
    component: UserUpdateTeacher,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users-for-editor/update-filter-teacher/:id',
    name: 'users-for-editor-update-filter-teacher',
    component: UserUpdateFilterTeacher,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users-for-editor/show/:id',
    name: 'users-for-editor-show',
    component: UserShow,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users-for-editor/push/:id',
    name: 'users-for-editor-push',
    component: UserPush,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/users-for-editor/router.js